import React from 'react';
import isEmpty from 'lodash/isEmpty'

export default class ContactRow extends React.Component {
  constructor(props) {
    super(props);
    this.openModal = this.openModal.bind(this)
  }

  getInfoArr(arr, get_key=null) {
    if(!isEmpty(arr)) {
      if(get_key === null) {
        return arr
      } else {
        if(arr.hasOwnProperty(get_key)) {
          if(arr[get_key]) {
            return arr[get_key]
          } else {
            return "-"
          }
        }
      }
    }
  }

  openModal() {
    const {RowData, setDataEdit} = this.props;
    setDataEdit(RowData)
  }

  renderStatus() {
    const {RowData} = this.props

    if(RowData.Active) {
      return (<span className="badge badge-success" style={{padding: "6px 8px", borderRadius: '4px'}}>Active</span>)
    }else {
      return (<span className="badge badge-danger" style={{padding: "6px 8px", borderRadius: '4px'}}>Disabled</span>)
    }

  }

  render() {
    const {RowData} = this.props

    return (
      <tr>
        <td>
          {this.getInfoArr(RowData.Username)}
        </td>
        <td>
          {this.getInfoArr(RowData.FirstName) + " " + this.getInfoArr(RowData.LastName)}
        </td>
        <td>
          {this.getInfoArr(RowData.Phone)}
        </td>
        <td>
          {this.getInfoArr(RowData.City, "Name")}
        </td>
        <td >
          {this.getInfoArr(RowData.Role, "Name")}
        </td>
        <td className="text-center">
          {this.renderStatus()}
        </td>
        <td className="text-center">  
          <button className="btn btn-4r btn-sm btn-primary" onClick={()=>this.openModal('modal_update')}><i className="icon-pencil"></i></button>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/user/user/helper/component/UserRow.js